import React from 'react';
import PropTypes from 'prop-types';

function RightLegBorder({ color }) {
  return (
    <path
      d="M662.593 507.534C680.355 504.434 693.504 497.573 712.964 472.392C722.311 460.296 725.158 440.539 723.645 412.368C719.751 425.298 714.994 436.486 709.522 440.652C693.499 452.863 661.444 465.837 620.997 465.074C608.595 464.84 597.785 463.312 588.738 461.31C590.025 465.08 591.363 468.787 592.761 472.388C608.789 513.596 652.443 509.306 662.593 507.534Z"
      fill={color}
    />
  );
}

RightLegBorder.propTypes = {
  color: PropTypes.string,
};

RightLegBorder.defaultProps = {
  color: '#383D43',
};

export default RightLegBorder;
